import { Fit, Layout, Rive } from '@rive-app/canvas-lite'
import { createSignal, onCleanup, onMount } from 'solid-js'
import paywallRive from '~/assets/anim/paywall.riv?url'

export function Hero() {
  let canvas!: HTMLCanvasElement // oxlint-disable-line eslint/no-unassigned-vars
  const [loaded, setLoaded] = createSignal(false)

  let onResize: () => void
  let rive: Rive

  onMount(() => {
    rive = new Rive({
      src: paywallRive,
      canvas,
      autoplay: true,
      layout: new Layout({
        fit: Fit.FitHeight,
      }),
      onLoad: () => {
        rive.resizeDrawingSurfaceToCanvas()
        onResize = () => rive.resizeDrawingSurfaceToCanvas()
        window.addEventListener('resize', onResize)
        setLoaded(true)
      },
    })
  })

  onCleanup(() => {
    rive.cleanup()
    window.removeEventListener('resize', onResize)
  })

  return (
    <div class="-mx-8 h-[308px] w-screen">
      <canvas
        ref={canvas}
        class="h-[308px] w-full transition-opacity duration-300"
        classList={{ 'opacity-0': !loaded(), 'opacity-100': loaded() }}
      />
    </div>
  )
}
